<div class="modal-body text-center">
  <p>{{ "bulletins.table.publishAllDialog.message" | translate }}</p>
  <button type="button" class="btn btn-primary" (click)="publishAllModalConfirm()">{{ "bulletins.table.publishAllDialog.accept" | translate }}</button>
  <button type="button" class="btn btn-default" (click)="publishAllModalDecline()">{{ "bulletins.table.publishAllDialog.reject" | translate }}</button>
</div>
